import React, { JSX, useState } from "react";
import { Outlet } from "react-router";
import {
    OrganizationSearchContext,
    OrganizationSearchCriteria,
    defaultOrganizationSearchCriteria,
} from "utilities/contexts/search/organization/organization-search-context";

interface AdminOrganizationLayoutProps {}

// Keeps OrganizationSearchCriteria in scope across the organizations list page and its detail routes, without leaking to other admin sections.
const AdminOrganizationLayout: React.FC<AdminOrganizationLayoutProps> = (): JSX.Element => {
    const [organizationSearchCriteria, setOrganizationSearchCriteria] =
        useState<OrganizationSearchCriteria>(defaultOrganizationSearchCriteria);

    return (
        <OrganizationSearchContext.Provider
            value={{
                initialCriteria: organizationSearchCriteria,
                setCriteria: setOrganizationSearchCriteria,
            }}>
            <Outlet />
        </OrganizationSearchContext.Provider>
    );
};

export { AdminOrganizationLayout };
